import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "@/utils/dsBridge";
import rfStore from "@/utils/rfStore";
import { useEffect, useState } from "react";

/**
 * Android 状态栏的高度
 */
export default function useAndroidStatusBarH() {
  const [h, setH] = useState(0);

  useEffect(() => {
    const isRFAndroidApp = rfStore.getRFState()?.model === "android";
    if (isRFAndroidApp) {
      bridge.call(
        BridgeCallHandlers.ON_GET_STATUS_BAR_HEIGHT,
        (res: string) => {
          if (res) {
            try {
              const data = JSON.parse(res);
              if (data.height) {
                setH(Number(data.height / 3));
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      );
    }
  }, []);

  return { h };
}
